// type guard for typescript in filter functions

function notUndefined<T>(x: T | undefined): x is T {
  return x !== undefined;
}

export default notUndefined;
